import axios from "axios";
import {appConfig} from "../config";

const axiosInstance = axios.create({
    baseURL:appConfig.appServerUrl
});
const accessToken = window.localStorage.getItem("accessToken")
axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    )
);

export default axiosInstance;
